<template>
  <table class="table table-sm" style="font-size:0.8em;font-weight:bold;">
    <thead>
    <tr class="table-secondary">
      <td style="text-align:center">Detay</td>
      <td style="text-align:center">Fiyat</td>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>
        Satış
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">{{ salesPrice }}</td>
    </tr>

    <tr>
      <td>
        Komisyon
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">
        (%{{
          ((productTotal.sumCommission / salesPrice) * 100).toFixed(1)
        }})
        {{ productTotal.sumCommission.toFixed(2) }}</td>
    </tr>

    <tr>
      <td>
        Kargo
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">{{ productTotal.sumCargo1.toFixed(2) }}</td>
    </tr>

    <tr class="table-secondary">
      <td>
        Stş. Kal.
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">{{ fromSalesPrice.toFixed(2) }}</td>
    </tr>
    <tr class="table-warning">
      <td>
        Hsp. Alış
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">{{ productTotal.sumCalPrice.toFixed(2) }}</td>
    </tr>

    <tr :class="fromSalesPrice - productTotal.sumCalPrice>0?'table-success':'table-danger'"
        v-if="productTotal.sumCalPrice"
    >
      <td>
        Hsp.Stş. K/Z
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">
        (%{{ ((fromSalesPrice - productTotal.sumCalPrice) / salesPrice * 100).toFixed(1) }})
        {{ (fromSalesPrice - productTotal.sumCalPrice).toFixed(2) }}
      </td>
    </tr>

    <tr :class="fromSalesPrice - productTotal.sumCalPrice>0?'table-success':'table-danger'"
        v-if="productTotal.sumCalPrice"
    >
      <td>
        Hsp.Alş. K/Z
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">
        (%{{ ((fromSalesPrice - productTotal.sumCalPrice) / productTotal.sumCalPrice * 100).toFixed(1) }})
        {{ (fromSalesPrice - productTotal.sumCalPrice).toFixed(2) }}
      </td>
    </tr>
    <tr class="table-info">
      <td>
        Seç. Alış
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">{{ productTotal.sumSelPrice.toFixed(2) }}</td>
    </tr>
    <tr :class="fromSalesPrice - productTotal.sumSelPrice>0?'table-success':'table-danger'"
        v-if="productTotal.sumSelPrice"
    >
      <td>
        Seç.Stş. K/Z
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">
        (%{{ ((fromSalesPrice - productTotal.sumSelPrice) / salesPrice * 100).toFixed(1) }})
        {{ (fromSalesPrice - productTotal.sumSelPrice).toFixed(2) }}
      </td>
    </tr>
    <tr :class="fromSalesPrice - productTotal.sumSelPrice>0?'table-success':'table-danger'"
        v-if="productTotal.sumSelPrice"
    >
      <td>
        Seç.Alş. K/Z
        <span style="float:right;">:</span>
      </td>
      <td class="numberTd">
        (%{{ ((fromSalesPrice - productTotal.sumSelPrice) / productTotal.sumSelPrice * 100).toFixed(1) }})
        {{ (fromSalesPrice - productTotal.sumSelPrice).toFixed(2) }}
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  name: 'OrderOrderAccounting',
  props: {
    order: Object,
  },
  computed: {
    salesPrice() {
      return this.order.sales_price
    },
    fromSalesPrice() {
      return this.salesPrice - (this.productTotal.sumCommission + this.productTotal.sumCargo1)
    },
    productTotal() {
      let total = {
        sumCommission: 0,
        sumCargo1: 0,
        sumCalPrice: 0,
        sumSelPrice: 0,
      }

      this.order.products.forEach(product => {
        if (product.product_accounting) {
          total.sumCommission += product.product_accounting.actual_commission * product.quantity
          total.sumCargo1 += product.product_accounting.actual_cargo1 * product.quantity
          total.sumCalPrice += product.product_accounting.calculated_purchase_price * product.quantity
          total.sumSelPrice += product.product_accounting.selected_purchase_price * product.quantity
        }
      })

      return total

    },
  },
}
</script>

<style scoped>
.numberTd {
  text-align: right;
}
</style>
